






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { ButtonAction, FieldScheme, StaticFieldType } from "@/components/pageGenerator/models";
import { PluginManager }                              from "@/pluginManager/portalPlugin";
import { ApiRoutes }                                  from "@/store/apiRoutes";
import Axios                                          from "axios";
import { Component, Prop, Vue }                       from "vue-property-decorator";

@Component({
             name      : "StaticFieldGenerator",
             components: {
               PluginComponent           : () => import("@/components/PluginComponent.vue"),
               InteractivePluginComponent: () => import("@/components/InteractivePluginComponent.vue")
             }
           })
export default class StaticFieldGenerator extends Vue {
  StaticFieldType = StaticFieldType;
  ButtonAction    = ButtonAction;

  @Prop({
          required: true,
          type    : Object as () => FieldScheme,
          default : {}
        })
  private field!: FieldScheme;

  private dialog = false;

  private pluginManager!: PluginManager;

  private gdpr        = false;
  private gdpr2       = false;
  private gdpr3       = false;
  private gdprSettings: unknown | undefined;
  private headerSettings: any | undefined;
  private headerStyle = "";
  private fancyHeadlineSettings: any | undefined;
  private footerSettings: any | undefined;
  private counterSettings: any | undefined;
  private sizableImageSettings: any | undefined;

  private counterValue = 0;
  private playerVars   = {
    autoplay: 1,
    color   : "white"
  };

  /*
   Headline      = "Headline",
   Paragraph     = "Paragraph",
   Image         = "Image",
   Video         = "Video",
   Button        = "Button",
   */
  private fancyParagraphSettings!: { text: string, color: string };
  private fancyButtonSettings!: { text: string, color: string };

  mounted() {
    if (this.field.type === StaticFieldType.SlideshowPlugin) {
      if (this.field.content != null) {
        const slideshowSettings     = JSON.parse(this.field.content);
        const script                = document.createElement("script");
        script.type                 = "text/javascript";
        window["slideshowSettings"] = slideshowSettings.settings;
        script.src                  = slideshowSettings.src;
        document.body.appendChild(script);
      }
    }


  }

  created() {
    if (this.field.type === StaticFieldType.Plugin) {
      this.pluginManager = new PluginManager(this.$route.params.eventId, this.$route.params?.contributionId);
    }
    if (this.field.type === StaticFieldType.ContributionCounter) {
      Axios.get(ApiRoutes.Contribution.Count.replace("{eventId}", this.$route.params.eventId))
           .then(countResponse => {
             this.counterValue = countResponse.data;
           });
    }
    if (this.field.type === StaticFieldType.Gdpr
        || this.field.type === StaticFieldType.WazaGdpr
        || this.field.type === StaticFieldType.SiemensGdpr
        || this.field.type === StaticFieldType.TelekomGdpr
        || this.field.type === StaticFieldType.AlexionGdpr
        || this.field.type === StaticFieldType.BayerGdpr
        || this.field.type === StaticFieldType.RocheGdpr
        || this.field.type === StaticFieldType.BonduelleGdpr
        || this.field.type === StaticFieldType.SephoraGdpr
        || this.field.type === StaticFieldType.SncfGdpr
        || this.field.type === StaticFieldType.SdlGdpr
        || this.field.type === StaticFieldType.PortzamparcGdpr
        || this.field.type === StaticFieldType.AltareaGdpr
        || this.field.type === StaticFieldType.ResmedGdpr
        || this.field.type === StaticFieldType.MiltenyiGdpr
        || this.field.type === StaticFieldType.SanofiGdpr
        || this.field.type === StaticFieldType.GaldermaGdpr
        || this.field.type === StaticFieldType.TarkettGdpr
        || this.field.type === StaticFieldType.DanoneGdpr
        || this.field.type === StaticFieldType.UbpGdpr
        || this.field.type === StaticFieldType.AbbGdpr
        || this.field.type === StaticFieldType.RuvGdpr
        || this.field.type === StaticFieldType.GobainGdpr
        || this.field.type === StaticFieldType.ManGdpr
        || this.field.type === StaticFieldType.BobstGdpr
        || this.field.type === StaticFieldType.MindozaGdpr) {
      if (this.field.content != null) {
        this.gdprSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.FancyHeadline) {
      if (this.field.content != null) {
        this.fancyHeadlineSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.FancyButton) {
      if (this.field.content != null) {
        this.fancyButtonSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.FancyParagraph) {
      if (this.field.content != null) {
        this.fancyParagraphSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.PageFooter || this.field.type === StaticFieldType.OrangePageFooter) {
      if (this.field.content != null) {
        this.footerSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.ContributionCounter) {
      if (this.field.content != null) {
        this.counterSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.SizableImage) {
      if (this.field.content != null) {
        this.sizableImageSettings = JSON.parse(this.field.content);
      }
    }
    if (this.field.type === StaticFieldType.PageHeader
        || this.field.type === StaticFieldType.FullImagePageHeader) {
      if (this.field.content != null) {
        this.headerSettings = JSON.parse(this.field.content);
        if (this.headerSettings) {
          this.headerStyle = this.headerSettings.Border
                             ? ("border-bottom: 5px solid" + this.headerSettings.BorderColor)
                             : "";
          this.headerStyle += this.headerSettings.BackgroundColor
                              ? "background: " + this.headerSettings.BackgroundColor
                              : "";
        }
      }
    }

  }

}
